const CompanyLogo = (props) => {
    return (
        <div className="marquee-card" title={props.data.fullName}>
            <img src={props.data.logo} className="marquee-logo" alt={props.data.fullName} />
            <span className="marquee-name">{props.data.fullName}</span>
        </div>
    );
};

export default CompanyLogo;
